export default class MidlistGoogle extends React.Component {
  componentDidMount() {
    if (this.props.show_ads) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    if (this.props.show_ads) {
      return (
        <ins className="adsbygoogle"
             style={{display: 'none'}}
             data-ad-format="fluid"
             data-ad-layout-key="-d5+9y-1w-dd+v4"
             data-ad-client="ca-pub-3673800954269220"
             data-ad-slot="1746400518"></ins>
      );
    }
    return <div></div>;
  }
}
